import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-t_bot",
  "use": "icon-t_bot-usage",
  "viewBox": "0 0 16 19",
  "content": "<symbol viewBox=\"0 0 16 19\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-t_bot\">\n<path id=\"icon-t_bot_&#229;&#189;&#162;&#231;&#138;&#182;&#231;&#187;&#147;&#229;&#144;&#136;&#229;&#164;&#135;&#228;&#187;&#189;\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M9.64463 18.1382C8.84933 19.287 7.15117 19.287 6.35586 18.1382L1.173 10.6519C0.254679 9.32542 1.20406 7.51346 2.81738 7.51346H5.50025V2.51346C5.50025 1.40889 6.39568 0.513462 7.50025 0.513462H8.50025C9.60482 0.513462 10.5002 1.40889 10.5002 2.51346V7.51346H13.1831C14.7964 7.51346 15.7458 9.32542 14.8275 10.6519L9.64463 18.1382Z\" fill=\"#FFA741\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/t_bot.svg
// module id = Mf8n
// module chunks = 102